import ConfigProvider from '../../config/ConfigProvider';
import { Environment, Locale, ShopBundle } from '../../types';
import I18nProvider from '../I18nProvider';
import KeycloakTokenProvider from '../KeycloakTokenProvider';
import OverlaysProvider from '../OverlaysProvider';
import Providers from '../Providers';
import ThunkDispatchProvider from '../providers/ThunkDispatchProvider';
import SentryErrorBoundary from '../SentryErrorBoundary';

import RetryPaymentOverlays from './overlays';
import RetryDataProvider from './RetryDataProvider';
import RetryPaymentSwitch from './RetryPaymentSwitch';

export type RetryPaymentProps = {
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  orderId: string;
  customerId: string;
  env: Environment;
};

const RetryPayment: React.FC<RetryPaymentProps> = ({
  shopBundle,
  domain,
  locale,
  orderId,
  customerId,
  env,
}) => {
  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary>
          <Providers shopBundle={shopBundle} domain={domain} locale={locale}>
            <KeycloakTokenProvider>
              <RetryDataProvider customerId={customerId}>
                <ThunkDispatchProvider>
                  <OverlaysProvider>
                    <RetryPaymentSwitch orderId={orderId} customerId={customerId} />
                    <RetryPaymentOverlays />
                  </OverlaysProvider>
                </ThunkDispatchProvider>
              </RetryDataProvider>
            </KeycloakTokenProvider>
          </Providers>
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default RetryPayment;
